import { ThreeEvent } from '@react-three/fiber';
import { BaseTool } from '../BaseTool';


/**
 * Set Work Plane Tool
 * 
 * Allows picking a planar face to set as the active work plane.
 */
export class SetWorkPlaneToolClass extends BaseTool {
    id = 'SET_WORK_PLANE';
    name = 'Set Work Plane';
    cursor = 'crosshair';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        // Manual scene raycast: element meshes carry no R3F handlers, so
        // event.intersections only ever contains the event-catching plane.
        const intersection = this.raycastSceneAtEvent(event).find(
            (hit) => hit.face && hit.object.visible && !hit.object.userData?.isEventPlane
        );
        if (!intersection) return;

        // If it has a face
        if (intersection.face) {
            const normal = intersection.face.normal.clone().transformDirection(intersection.object.matrixWorld).normalize();
            const point = intersection.point;

            // Set work plane
            // We assume the origin is the hit point, or projected point?
            // Usually BIM projects the origin to the plane defined by face.

            // Update Store
            this.context.appStore.updateView({
                workPlane: {
                    origin: [point.x, point.y, point.z],
                    normal: [normal.x, normal.y, normal.z],
                    visible: true
                }
            });

            console.log('Work Plane Set:', point, normal);

            // Done
            this.deactivate();
            this.context.appStore.setActiveTool('select');
        }
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;

        // Highlight face under cursor?
        const intersection = this.raycastSceneAtEvent(event).find(
            (hit) => hit.face && hit.object.visible && !hit.object.userData?.isEventPlane
        );
        if (intersection && intersection.face) {
            // Preview logic would go here
        }
    }

    onPointerUp(): void { }
}

/**
 * Show Work Plane Tool (Toggle)
 */
export class ShowWorkPlaneToolClass extends BaseTool {
    id = 'SHOW_WORK_PLANE';
    name = 'Show Work Plane';
    cursor = 'default';

    activate(context: any) {
        super.activate(context);
        // Toggle visibility
        const current = context.appStore.getState().view.workPlane;
        if (current) {
            context.appStore.updateView({
                workPlane: { ...current, visible: !current.visible }
            });
            console.log('Work Plane Visibility:', !current.visible);
        } else {
            console.warn('No active work plane to show.');
        }

        // Immediately exit
        this.deactivate();
        context.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
